"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvironment = function (wixCodeApi) { return ({
    isEditor: wixCodeApi.window.viewMode === 'Editor',
    isPreview: wixCodeApi.window.viewMode === 'Preview',
    isSSR: wixCodeApi.window.rendering.env === 'backend',
    isDebug: wixCodeApi.location.query.debug || wixCodeApi.location.query.ssrDebug,
}); };
function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
exports.isValidEmail = isValidEmail;
var COMPONENT_ID;
(function (COMPONENT_ID) {
    COMPONENT_ID["GROUP_LIST"] = "groups";
    COMPONENT_ID["GROUP_PAGE"] = "group";
    COMPONENT_ID["GROUPS_AREA"] = "groups_area";
})(COMPONENT_ID = exports.COMPONENT_ID || (exports.COMPONENT_ID = {}));
//# sourceMappingURL=utils.js.map